import React, {PropTypes} from "react";
import DatePicker from "material-ui/DatePicker";
import Checkbox from "material-ui/Checkbox";
import Button from "react-bootstrap/lib/Button";

class SearchForm extends React.Component {

  constructor() {
    super();

  }

  componentDidMount() {

  }

  render() {
    console.log(this.props);
    return (<div className="col-md-12">
        <div className="col-md-3">
          <img src="/public/images/calendar.png" style={{paddingRight: '10'}}/>

          <DatePicker name="startDate"
                      inputStyle={{color: 'black'}}
                      container="inline"
                      dialogContainerStyle={{color: 'black', padding: 0}}
                      className="rowX"
                      component={DatePicker}
                      autoOk={true}

                      style={{
                        display: 'inline',
                        "font-family": '"ProximaNova-Regular", "sans-serif"',
                        padding: 0,
                        margin: 0,
                        color: 'red'
                      }}
                      mode={'portrait'}
                      textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                      value={this.props.dates.startDate}
                      onChange={this.props.changeDates}
                      shouldDisableDate={
                        (day)=> {
                          if (day.getDay() != 1)
                            return true;
                        }}

                      formatDate={(date)=> {
                        let end = date;
                        //end.setDate(date.getDate()+7);
                        //this.setState({start: date,end: end})
                        return (date.toString().substring(0, 16));
                      }}
                      floatingLabelText="Start Date"
                      hintText="Start Date"/>

        </div>
        <div className="col-md-3">
          <img src="/public/images/calendarO.png" style={{paddingRight: '10'}}/>
          <DatePicker name="endDate"
                      disabled={true}
                      container="inline"
                      style={{display: 'inline', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                      component={DatePicker}
                      autoOk={true}
                      onChange={(event, dates)=> {
                      }}
                      shouldDisableDate={
                        (day)=> {
                        }}
                      value={this.props.dates.endDate}

                      floatingLabelText="End Date"
                      textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                      mode={'portrait'}
                      formatDate={(date)=> {
                        return (date.toString().substring(0, 16));
                      }}
                      hintText="End Date "/>

        </div>
        <div className="col-md-2">
          <Checkbox
            style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
            inputStyle={{height: '30px'}}
            iconStyle={{fill: '#5cb85c'}}
            labelStyle={{fontSize: '15px'}}
            checked={this.props.indirect}
            label="Indirect"
            onCheck={this.props.changeIndirect}/>
        </div>

        <div className="col-md-2" style={{display: 'inline', marginTop: '3%'}}>
          <Button
            onClick={this.props.previous}>
            <img src="/public/images/back.png"/>
          </Button>
          <Button
            className="btn btn-group-sm"
            onClick={this.props.next}
          ><img src="/public/images/nextD.png"/> </Button>
        </div>


      </div>
    );
  }
}

SearchForm.propTypes = {};

export default SearchForm;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/AttendanceRoster/SearchForm.js
 **/